<template>
  <div>
    <v-autocomplete :items="items" prepend-inner-icon="mdi-magnify" class="mx-auto" density="comfortable" menu-icon=""
      label="Поиск по номеру приказа" style="max-width: 400px;" theme="light" variant="solo" item-props
      @update:search="findOrders" v-model="search" item-title="ordernum" :return-object="true"
      :clearable="true"></v-autocomplete>

    <template v-if="elements !== null">
      <div v-for="(elements, type) in this.elements">
        <h4 class="my-4">{{ types[type] }}</h4>
        <v-row>
          <v-col class="folder" align-self="center" cols="12" md="6" lg="4" xl="3" v-for="catalog in elements"
            :key="catalog.id">
            <router-link :to="{ path: 'catalog/' + catalog.id }">
              <img :src="$model.img_folder + '/blue-folder.png'" />
              {{ catalog.name }}
            </router-link>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-else>
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>
  </div>
</template>

<script>
import "../styles.css"
export default {
  data() {
    return {
      elements: null,
      types: {
        "staff": "Приказы по сотрудникам, документооборот",
        "student": "Приказы по студентам",
      },
      items: [],
      search: "",
      abortControl: [],
    };
  },
  watch: {
    search: function (val) {
      if (val) {
        window.open(this.$model.wwwroot + "/procollege/manage_groups/documents3/document/" + val.id);
      }
    }
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/catalogGetList"
      )
      .then((response) => {
        if (typeof response.data == "string") {
          throw new Error("Malformed response")
        }
        this.elements = response.data;
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });
  },
  methods: {
    findOrders(val) {
      if (!val) {
        return;
      }
      //уже отправленные и еще не обработанные запросы не интересны
      let abortControl_;
      while ((abortControl_ = this.abortControl.pop())) {
        abortControl_.abort();
      }
      //------------------------------------------
      abortControl_ = new AbortController();
      this.abortControl.push(abortControl_);

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/catalogGetOrdersByNum",
          new URLSearchParams({
            ordernum: val,
          }),
          {
            signal: abortControl_.signal,
          }
        )
        .then((response) => {
          if (typeof response.data == "string") {
            throw new Error("Malformed response")
          }
          this.abortControl = this.abortControl.filter(el => abortControl_ !== el)
          this.items = response.data;
        })
        .catch((error) => {
          this.abortControl = this.abortControl.filter(el => abortControl_ !== el)
          this.axiosDefaultErrorHandler(error);
        });
    }
  }
};
</script>